import { Button, Alert, AlertTitle, AlertDescription, AlertIcon, Collapse, Flex, useClipboard, IconButton } from '@chakra-ui/react';
import { mdiCheck, mdiContentCopy, mdiTriangle, mdiTriangleDown } from '@mdi/js';
import { Icon } from '@mdi/react';
import { useState } from 'react';
import { ErrorMessageType } from '../utils/surveyStatusSchemas';
import { addSpacesToCamelCase } from '../utils/textUtils';

const formatErrorToText = (error: ErrorMessageType) => `${[error.statusCode, error.title].join(': ')}\n${error.message}\n${error.correlationId ?? ''}`;

const ErrorModal = ({ error, defaultExpanded }: { error: ErrorMessageType; defaultExpanded?: boolean }) => {
    const [expanded, setExpanded] = useState(defaultExpanded ?? false);

    const { hasCopied, onCopy } = useClipboard(formatErrorToText(error));

    return (
        <>
            <Button
                margin={0}
                width="100%"
                rightIcon={<Icon path={expanded ? mdiTriangle : mdiTriangleDown} size=".5rem" />}
                justifyContent="space-between"
                variant="ghost"
                onClick={() => setExpanded(!expanded)}
                borderBottomRadius={expanded ? 0 : 'md'}
                backgroundColor="rgba(254, 178, 178, 0.16)"
            >
                {error.title}
            </Button>
            <Collapse in={expanded} unmountOnExit>
                <Alert key="errorMessage" status="error" alignItems="flex-start" variant="left-accent">
                    <AlertIcon />
                    <Flex flexDirection="column" gap="0.5rem">
                        <AlertTitle>{addSpacesToCamelCase(error?.statusCode || "")}</AlertTitle>
                        <AlertDescription>{error?.message}</AlertDescription>
                    </Flex>
                    <Flex alignItems="flex-start" justifyContent="flex-end" flex="1 1 auto">
                        <IconButton
                            variant="ghost"
                            icon={<Icon path={hasCopied ? mdiCheck : mdiContentCopy} size="1rem" />}
                            aria-label="Copy Error"
                            isDisabled={hasCopied}
                            onClick={onCopy}
                        />
                    </Flex>
                </Alert>
            </Collapse>
        </>
    );
};

export default ErrorModal;
